<template>
  <div>
    <dialog-confirm
      v-if="context === 'update'"
      ref="update-title-dialog"
      :confirm-text="$t('yes')"
      :reject-text="$t('no')">
      <template #title>
        {{ $t('reports_ui.update_report_title_query') }}
      </template>
      <div class="text-subtitle-1">
        {{ $t('reports_ui.report_parameters_title_change_text')}}
      </div>
      <h5 class="mt-2">
        {{ defaultReportName() }}
      </h5>
    </dialog-confirm>
    <v-form class="d-flex">
      <v-row>
        <v-col md="6" cols="12" v-if="context !== 'create'">
          <v-text-field
            v-model="localReport.name"
            :label="$tc('name')"
            prepend-inner-icon="mdi-form-textbox" />
        </v-col>
        <v-col md="6" cols="12">
          <date-picker
            v-model="startDate"
            type="month"
            :timezone="timezone"
            :output-moment="true"
            :today="false"
            :label="$t('reports_ui.monthly_route_status_report.report_month')"
            prepend-inner-icon="mdi-calendar" />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DatePicker from '@/components/shared/DatePicker'
import DialogConfirm from '../shared/DialogConfirm'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import ReportFormMixin from '@/components/report/ReportFormMixin'
import Moment from 'moment-timezone'
import { requiredIf } from 'vuelidate/lib/validators'
import { get, map } from 'lodash'

export default {
  name: 'MonthlyRouteStatusReportForm',
  components: {
    DatePicker,
    DialogConfirm
  },
  mixins: [
    CurrentUserMixin,
    ApiUtilitiesMixin,
    ReportFormMixin
  ],
  validations: {
    localReport: {
      name: {
        required: requiredIf(function () {
          return this.action !== 'create'
        })
      }
    }
  },
  data () {
    return {
      reportType: 'MonthlyRouteStatusReport',
      startDate: null
    }
  },
  methods: {
    /** Hook to populate report (called from mixin) */
    populateReportForm () {
      const preSelectedStartDate = get(this, 'report.parameters.startDate')
      if (preSelectedStartDate) {
        this.startDate = Moment.tz(preSelectedStartDate, this.timezone)
      } else {
        // Default to beginning of last month
        this.startDate = Moment().tz(this.timezone).subtract(1, 'month').startOf('month')
      }
    },
    /**
     * Override mixin method setLocalParameters, so we can prompt and update the report name when the report parameters
     * change.
     * @param reportParameters
     * @returns {Promise<void>}
     */
    async setLocalReportParameters (reportParameters) {
      if (this.action === 'create' || this.action === 'duplicate') {
        this.localReport = this.$orm('Report').createRecord({
          type: this.reportType,
          name: this.localReport.name || this.defaultReportName(),
          parameters: reportParameters
        })
      } else {
        const changed = reportParameters.startDate !== get(this.report, 'parameters.startDate')
        if (changed && await this.$refs['update-title-dialog'].confirm()) {
          this.localReport.name = this.defaultReportName()
        }
        this.localReport.parameters = reportParameters
      }
    },
    /**
     * Implement ReportFormMixin method buildReportParameters
     * @returns {{}}
     */
    buildReportParameters () {
      const reportParameters = {}
      reportParameters.startDate = Moment.tz(this.startDate, this.timezone).format()
      // End date is automatically set to the end of the month
      reportParameters.endDate = Moment.tz(this.startDate, this.timezone).endOf('month').format()
      // Report customers is automatically set to the user's available customers
      reportParameters.customerIds = map(this.customers, x => x.id)
      reportParameters.timezone = this.timezone
      return reportParameters
    },
    /**
     * Implement ReportFormMixin method defaultReportName
     * @returns {string}
     */
    defaultReportName () {
      return `${this.$t('reports_ui.monthly_route_status_report.name')} (${this.startDate.format('MM/YYYY')})`
    }
  }
}
</script>

<style scoped>

</style>
